import moment from "moment";

export default {
    formatCurrency(value) {
        return value
            ? 'R$ ' + value.toLocaleString('pt-BR', {minimumFractionDigits: 2})
            : 'R$ 0,00'
    },
};
